UC = UC || {};
UC.timesheetComponent = UC.timesheetComponent || {};

UC.timesheetComponent.TimesheetInvoices = Backbone.Collection.extend({

  model: UC.timesheetComponent.TimesheetInvoice

});
